import { portfolioItems } from "@/data/eventOrganizerContent";

const PortfolioSection = () => {
  return (
    <section id="portfolio" data-testid="portfolio-section" className="space-y-10 py-24">
      <div className="max-w-3xl space-y-4">
        <p
          data-testid="portfolio-eyebrow-text"
          className="inline-flex rounded-full border border-fuchsia-200 bg-fuchsia-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.16em] text-fuchsia-700"
        >
          Selected Work
        </p>
        <h2 data-testid="portfolio-heading" className="text-3xl leading-tight text-violet-950 md:text-5xl">
          Corporate event experiences delivered with precision and executive-level polish.
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        {portfolioItems.map((item, index) => (
          <article
            key={item.title}
            data-testid={`portfolio-card-${index + 1}`}
            className="portfolio-frame group relative overflow-hidden rounded-2xl border border-fuchsia-200 bg-violet-50/75"
          >
            <div className="aspect-[4/5]">
              <img
                src={item.image}
                alt={item.title}
                data-testid={`portfolio-image-${index + 1}`}
                className="h-full w-full object-cover object-center"
              />
            </div>
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/75 via-black/30 to-transparent p-5 text-stone-50">
              <p
                data-testid={`portfolio-category-${index + 1}`}
                className="text-xs uppercase tracking-[0.14em] text-fuchsia-200"
              >
                {item.category}
              </p>
              <h3 data-testid={`portfolio-title-${index + 1}`} className="mt-1 text-xl">
                {item.title}
              </h3>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default PortfolioSection;